module.exports = __webpack_public_path__ + "img/icon.58b11dc8.svg";